// extracted by mini-css-extract-plugin
var _1 = "CountdownTimer_colon__IUpiP";
var _2 = "CountdownTimer_timeBlock__P3CaN";
var _3 = "CountdownTimer_timeContainer__wotdO";
var _4 = "CountdownTimer_timer__rKP4o";
var _5 = "CountdownTimer_timerHeader__G8VVz";
export { _1 as "colon", _2 as "timeBlock", _3 as "timeContainer", _4 as "timer", _5 as "timerHeader" }
